function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WFFM_SELECTORS = {
  scfForm: '.scfForm',
  scfTitleBorder: '.scfTitleBorder',
  scfIntroBorder: '.scfIntroBorder',
  scfValidationSummary: '.scfValidationSummary',
  scfSubmitSummary: '.scfSubmitSummary',
  scfSectionBorder: '[class*="scf"][class*="SectionBorder"]',
  scfSectionLegend: '.scfSectionLegend',
  scfSectionContent: '.scfSectionContent',
  scfEntry: '[class*="name."]',
  scfLabel: '[class*="scf"][class*="Label"]',
  scfGeneralPanel: '[class*="scf"][class*="GeneralPanel"]',
  scfUsefulInfo: '[class*="scf"][class*="UsefulInfo"]',
  scfValidator: '.scfValidator',
  scfRequired: '[class*="scf"][class*="Required"]',
  scfFooterBorder: '.scfFooterBorder',
  scfSubmitButtonBorder: '.scfSubmitButtonBorder',
  scfValidatorRequired: '.scfValidatorRequired',
  scfInput: '[name]'
};
var WDHWebFormForMarketers = /*#__PURE__*/function () {
  function WDHWebFormForMarketers(formList, options) {
    _classCallCheck(this, WDHWebFormForMarketers);
    this.formList = Array.prototype.slice.call(formList);
    this.defaultOptions = {
      showValidatorsOnErrors: true,
      moveAsteriskToLabel: false,
      maxEntriesInValidatorSummary: Number.MAX_SAFE_INTEGER,
      niceSelectClass: null,
      usefulInfoAsPlaceholder: false
    };
    this.options = Object.assign(this.defaultOptions, options || {});
  }
  return _createClass(WDHWebFormForMarketers, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.formList.forEach(function (form) {
        if (_this.options.showValidatorsOnErrors) {
          // SHOW validator hints when field has error
          _this.getEntries(form).forEach(function (entry) {
            if (_this.hasErrors(entry)) {
              Array.prototype.slice.call(entry.querySelectorAll(WFFM_SELECTORS.scfValidator)).forEach(function (validator) {
                validator.style.display = 'block';
              });
            }
          });
        }
        if (_this.options.moveAsteriskToLabel) {
          // MOVE scfRequired elements to label
          _this.getEntries(form).forEach(function (entry) {
            var labels = _this.getLabel(entry);
            var label = labels.length > 0 ? labels[0] : null;
            var required = _this.getRequired(entry);
            // MOVE scfRequired elements to label
            if (required.length && label) {
              required.forEach(function (requiredElement) {
                label.appendChild(requiredElement);
              });
            } else if (label) {
              label.insertAdjacentHTML('beforeend', '<span class="scfNotRequired">&nbsp;</span>');
            }
          });
        }
        if (_this.options.usefulInfoAsPlaceholder) {
          var panels = _this.scfGeneralPanel();
          panels.forEach(function (panel) {
            var input = panel.querySelector(WFFM_SELECTORS.scfInput);
            var usefullInfo = panel.querySelector(WFFM_SELECTORS.scfUsefulInfo);
            if (input && usefullInfo && input.type !== 'checkbox' && input.type !== 'radio') {
              input.setAttribute('placeholder', usefullInfo.textContent);
              usefullInfo.style.display = 'none';
            }
          });
        }
        if (_this.getValidationSummaryItems(form).length > _this.options.maxEntriesInValidatorSummary) {
          // LIMIT number of items in validation summary
          Array.prototype.slice.call(form.querySelectorAll("".concat(WFFM_SELECTORS.scfValidationSummary, " li:nth-child(1n + ").concat(_this.options.maxEntriesInValidatorSummary + 1, ")"))).forEach(function (listItem) {
            listItem.style.display = 'none';
          });
          form.querySelector("".concat(WFFM_SELECTORS.scfValidationSummary, " li:nth-child(1n + ").concat(_this.options.maxEntriesInValidatorSummary, ")")).innerHTML('...');
        }
        if (_this.options.niceSelectClass != null) {
          // ADD custom classes to jquery nice select - supports string and array of strings
          Array.prototype.slice.call(form.querySelectorAll('.nice-select')).forEach(function (niceSelect) {
            if (_this.options.niceSelectClass.constructor === Array) {
              _this.options.niceSelectClass.forEach(function (customClass) {
                niceSelect.classList.add(customClass);
              });
            } else {
              niceSelect.classList.add(_this.options.niceSelectClass);
            }
          });
        }

        // CLEAN UP OF MARKUP
        // HIDE empty scf***UsefulInfo tags - cleans i
        Array.prototype.slice.call(form.querySelectorAll(WFFM_SELECTORS.scfUsefulInfo)).forEach(function (element) {
          if (element.textContent.trim() === '') {
            element.style.display = 'none';
          }
        });
        // CLEAN UP OF MARKUP - end
      });
    }
  }, {
    key: "scfForm",
    value: function scfForm() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfForm);
    }
  }, {
    key: "scfTitleBorder",
    value: function scfTitleBorder() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfTitleBorder);
    }
  }, {
    key: "scfIntroBorder",
    value: function scfIntroBorder() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfIntroBorder);
    }
  }, {
    key: "scfValidationSummary",
    value: function scfValidationSummary() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfValidationSummary);
    }
  }, {
    key: "scfSubmitSummary",
    value: function scfSubmitSummary() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfSubmitSummary);
    }
  }, {
    key: "scfSectionBorder",
    value: function scfSectionBorder() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfSectionBorder);
    }
  }, {
    key: "scfSectionLegend",
    value: function scfSectionLegend() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfSectionLegend);
    }
  }, {
    key: "scfSectionContent",
    value: function scfSectionContent() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfSectionContent);
    }
  }, {
    key: "scfEntry",
    value: function scfEntry() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfEntry);
    }
  }, {
    key: "scfLabel",
    value: function scfLabel() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfLabel);
    }
  }, {
    key: "scfGeneralPanel",
    value: function scfGeneralPanel() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfGeneralPanel);
    }
  }, {
    key: "scfUsefulInfo",
    value: function scfUsefulInfo() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfUsefulInfo);
    }
  }, {
    key: "scfValidator",
    value: function scfValidator() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfValidator);
    }
  }, {
    key: "scfRequired",
    value: function scfRequired() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfRequired);
    }
  }, {
    key: "scfFooterBorder",
    value: function scfFooterBorder() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfFooterBorder);
    }
  }, {
    key: "scfSubmitButtonBorder",
    value: function scfSubmitButtonBorder() {
      return this.getElementsFromQuery(WFFM_SELECTORS.scfSubmitButtonBorder);
    }

    // Private methods
  }, {
    key: "getEntries",
    value: function getEntries(form) {
      var elements = [];
      Array.prototype.slice.call(form.querySelectorAll(WFFM_SELECTORS.scfGeneralPanel)).forEach(function (element) {
        elements.push(element.parentElement);
      });
      return elements;
    }
  }, {
    key: "hasErrors",
    value: function hasErrors(formOrEntry) {
      return Array.prototype.slice.call(formOrEntry.querySelectorAll(WFFM_SELECTORS.scfValidatorRequired)).length > 0;
    }
  }, {
    key: "getLabel",
    value: function getLabel(formOrEntry) {
      return Array.prototype.slice.call(formOrEntry.querySelectorAll(WFFM_SELECTORS.scfLabel));
    }
  }, {
    key: "getRequired",
    value: function getRequired(formOrEntry) {
      return Array.prototype.slice.call(formOrEntry.querySelectorAll(WFFM_SELECTORS.scfRequired));
    }
  }, {
    key: "getValidationSummaryItems",
    value: function getValidationSummaryItems(form) {
      return Array.prototype.slice.call(form.querySelectorAll("".concat(WFFM_SELECTORS.scfValidationSummary, " li")));
    }
  }, {
    key: "getElementsFromQuery",
    value: function getElementsFromQuery(query) {
      var elements = [];
      this.formList.forEach(function (form) {
        Array.prototype.slice.call(form.querySelectorAll(query)).forEach(function (element) {
          elements.push(element);
        });
      });
      return elements;
    }
  }]);
}();
export default WDHWebFormForMarketers;